import BaseController from "./base_controller";
import ToastController from "./toast_controller";

export default class extends BaseController
{
	static targets = [
		"extendButton", "testElement", "extendTemplate", "extendParameters", "closeExtend", "deleteButton",
		"noTests"
	];

	CURRENT_ACTIVE_TEST_INDEX = null;

	connect()
	{
		this.siteNum = this.data.get("siteNum");
		this.devNum = this.data.get("devNum");
		//this.testDeleteButtonTarget.disabled = true;

		this.deleteButtonTargets.forEach(button => button.addEventListener("click", e=>
		{
			e.stopPropagation();
		}))

		this.extendButtonTargets.forEach(button => button.addEventListener("click", e =>
		{
			e.preventDefault();
			e.stopPropagation();
			let wrapperElement = button.closest(".wrapper"),
				testElement = wrapperElement.querySelector(".test");
		
			let { testNum, devNum, testExpireDate } = testElement.dataset;

			let extendElement = this.extendTemplateTarget.content.cloneNode(true),
				form = extendElement.querySelector("form");
			
			form.action = form.action + `?test_num=${testNum}&dev_num=${devNum}`;
			extendElement.firstElementChild.dataset["testExpireDate"] = testExpireDate;

			wrapperElement.appendChild(extendElement);
			button.classList.add("hidden");
			button.nextElementSibling.classList.remove("hidden");
		}));

		this.closeExtendTargets.forEach(button => button.addEventListener("click", e =>
		{
			e.preventDefault();
			e.stopPropagation();
			let wrapperElement = button.closest(".wrapper");
			wrapperElement.lastElementChild.remove();
			button.classList.add("hidden");
			button.previousElementSibling.classList.remove("hidden");
		}))
	}

	handleDeleteResponse(event)
	{
		if (event.detail[0].success)
		{
			const createEvent = new CustomEvent("show-toast", { detail: "Test successfully deleted!" });
			window.dispatchEvent(createEvent);

			let section = event.target.closest(`.section`);
			let activeTestGrid = event.target.closest(".active-test-grid");
			event.target.closest(".wrapper").remove();
			
			if(activeTestGrid.children.length == 0)
			{
				activeTestGrid.parentElement.remove();
			}

			if(section.children.length == 1)
			{
				let div = document.createElement("div");
				div.innerHTML = ` <div class="no-tests text-muted mt-3" data-target="tests.noTests">There are currently no active tests.</div>`;
				section.appendChild(div.firstElementChild);
			}
		}
		else
		{
			const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: \n" + event.detail[0].error });
			window.dispatchEvent(errorEvent);
		}

	}

	handleResponse(event)
	{
		if (event.detail[0].success)
		{
			const createEvent = new CustomEvent("show-toast", { detail: "Test successfully created!" });
			window.dispatchEvent(createEvent);
			const clearNewTestEvent = new CustomEvent("clear-new-test");
			window.dispatchEvent(clearNewTestEvent);

			this.loadList();
			this.loadActiveDeviceList();
		}
		else
		{
			const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error });
			window.dispatchEvent(errorEvent);
		}
	}




	loadList()
	{
		this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/tests/list`), this.listTarget);
	}

	loadActiveDeviceList()
	{
		this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/tests/active_list`), this.activeListTarget)
	}

	loadNew()
	{
		this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/tests/new`), this.newTarget)
			.then(() =>
			{
				App.applyFlatpickr();
			});
	}

	loadEventList(event)
	{
		let testNum = event.currentTarget.dataset.testNum;
		this.highlightRow(this.testRowTargets, this.testRowTargets.indexOf(event.currentTarget));
		this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/tests/${testNum}/list`), this.eventListTarget);
	}

	loadActiveEventList(event)
	{
		let testNum = event.currentTarget.dataset.testNum;
		this.CURRENT_ACTIVE_TEST_INDEX = this.activeTestRowTargets.indexOf(event.currentTarget);
		this.testNumFieldTarget.value = event.currentTarget.dataset["testNum"];
		this.testNumFieldExtendTarget.value = event.currentTarget.dataset["testNum"];

		this.highlightRow(this.activeTestRowTargets, this.CURRENT_ACTIVE_TEST_INDEX);
		this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/tests/${testNum}/list`), this.activeEventListTarget);
	}

	selectTestType(event)
	{
		if (event.currentTarget.value === "All") this.testDetailsTarget.classList.add("hidden");
		else this.testDetailsTarget.classList.remove("hidden");
	}

	highlightRow(targets, index)
	{
		this.removeAllRowHighlights(targets);
		let rowTarget = targets[index];
		if (!rowTarget.classList.contains("bg-indigo-100"))
		{
			rowTarget.classList.add("bg-indigo-100");
		}
		this.testDeleteButtonTarget.disabled = false;
		this.testExtendButtonTarget.disabled = false;

	}

	removeAllRowHighlights(targets)
	{
		for (const rowTarget of targets)
		{
			if (rowTarget.classList.contains("bg-indigo-100"))
			{
				rowTarget.classList.remove("bg-indigo-100");
			}
		}
	}

	handleTestDeleteResponse(event)
	{
		var rowToDelete = this.activeTestRowTargets[this.CURRENT_ACTIVE_TEST_INDEX];
		rowToDelete.remove();
		this.activeEventListTarget.innerHTML = "Choose a test above to view its event list.";
		this.CURRENT_ACTIVE_TEST_INDEX = null;

		this.testDeleteButtonTarget.disabled = true;
		this.testExtendButtonTarget.disabled = true;
		setTimeout(() =>
		{
			this.testDeleteButtonTarget.disabled = true;
		}, 10)

		const trigger = new CustomEvent("show-toast", { detail: "Test successfully deleted!" });
		window.dispatchEvent(trigger);
	}

	deleteTest(event)
	{
		if (this.CURRENT_ACTIVE_TEST_INDEX == null)
		{
			event.preventDefault();
			return;
		}
	}

	extendTest(event)
	{
		if (this.CURRENT_ACTIVE_TEST_INDEX == null)
		{
			event.preventDefault();
			return;
		}
	}

	changeTab(event)
	{
		let selectedTab = event.currentTarget.dataset["name"];

		this.activeDeviceTestContentTarget.classList.add("hidden");
		this.newTestContentTarget.classList.add("hidden");
		this.testHistoryContentTarget.classList.add("hidden");

		this.activeDeviceTestTabTarget.classList.remove("active");
		this.newTestTabTarget.classList.remove("active");
		this.testHistoryTabTarget.classList.remove("active");

		event.currentTarget.classList.add("active");

		switch (selectedTab)
		{
			case "ActiveDeviceTest":
				{
					this.activeDeviceTestContentTarget.classList.remove("hidden");
					return;
				}
			case "NewTest":
				{
					this.newTestContentTarget.classList.remove("hidden");
					return;
				}
			case "TestHistory":
				{
					this.testHistoryContentTarget.classList.remove("hidden");
					return;
				}
		}
	}

	showExtendParameters(event)
	{
		let activeTest = this.activeTestRowTargets[this.CURRENT_ACTIVE_TEST_INDEX];
		let expiryDateTime = activeTest.children[7].innerText.split(" ");

		let expiryDate = expiryDateTime[0],
			expiryTime = expiryDateTime[1];

		this.extendPickerDateTarget._flatpickr.setDate(new Date(expiryDate + " 00:00"));
		this.extendPickerTimeTarget._flatpickr.setDate(expiryTime, "mm:HH");

		this.extendParametersTarget.classList.remove("hidden");
	}

	
}
